export const getCellId = ({ isBreakdown, field, rowId }) => {
  return `${+!!isBreakdown}${field}${rowId}`;
};

export default getCellId;
